var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.58128 3.5 4 7.08128 4 11.5C4 15.9187 7.58128 19.5 12 19.5C16.4187 19.5 20 15.9187 20 11.5C20 7.08128 16.4187 3.5 12 3.5ZM2 11.5C2 5.97672 6.47672 1.5 12 1.5C17.5233 1.5 22 5.97672 22 11.5C22 17.0233 17.5233 21.5 12 21.5C6.47672 21.5 2 17.0233 2 11.5ZM9.5073 7.6298C9.82081 7.45229 10.2056 7.45715 10.5145 7.64251L15.5145 10.6425C15.8157 10.8232 16 11.1487 16 11.5C16 11.8513 15.8157 12.1768 15.5145 12.3575L10.5145 15.3575C10.2056 15.5429 9.82081 15.5477 9.5073 15.3702C9.19379 15.1927 9 14.8603 9 14.5V8.5C9 8.13973 9.19379 7.80731 9.5073 7.6298Z",
    fill: "#646D7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.46514977442d8dcbb8e85eed598be39c.svg";
export { ForwardRef as ReactComponent };